export function updateMountedBobState(input) {
    const { mounted, walkDist, bob, horizontalDist, onGround, isDeadOrDying, isSwimming } = input;
    if (mounted) {
        return {
            prevWalkDist: walkDist,
            prevBob: bob,
            walkDist,
            bob: 0,
        };
    }
    const nextWalkDist = walkDist + horizontalDist * 0.6;
    const bobTarget = (onGround && !isDeadOrDying && !isSwimming) ? Math.min(0.1, horizontalDist) : 0;
    return {
        prevWalkDist: walkDist,
        prevBob: bob,
        walkDist: nextWalkDist,
        bob: bob + (bobTarget - bob) * 0.4,
    };
}
export function updateMountedMovementState(input) {
    const { mounted, velocity, onGround, isSneaking, isFlying, timeOffGround, deltaTime } = input;
    if (mounted) {
        return { movementState: 'NOT_MOVING', timeOffGround: 0 };
    }
    const nextTimeOffGround = onGround ? 0 : timeOffGround + deltaTime;
    if (isSneaking || isFlying || nextTimeOffGround > 0) {
        return { movementState: 'SNEAKING', timeOffGround: nextTimeOffGround };
    }
    const velocityThreshold = 0.01;
    const sprintingVelocity = 0.15;
    if (Math.abs(velocity.x) > velocityThreshold || Math.abs(velocity.z) > velocityThreshold) {
        return {
            movementState: Math.abs(velocity.x) > sprintingVelocity || Math.abs(velocity.z) > sprintingVelocity
                ? 'SPRINTING'
                : 'WALKING',
            timeOffGround: nextTimeOffGround,
        };
    }
    return { movementState: 'NOT_MOVING', timeOffGround: nextTimeOffGround };
}
